import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";
export const useUpdateFaqMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.put(`${API_ROUTES.UPDATE_FAQ}/${data?.id}`, {
          question: data?.question,
          answer: data?.answer,
        }),
      onSuccess: () => {
        showToast("success", "Faq updated successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_FAQ);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
export const useGetFaqQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_FAQ],
    queryFn: () => api.get(API_ROUTES.GET_FAQ),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};
export const useAddFaqMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.post(API_ROUTES.ADD_FAQ, data),
      onSuccess: () => {
        showToast("success", "Faq added successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_FAQ);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
export const useDeleteFaqMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) => api.delete(`${API_ROUTES.DELETE_FAQ}/${id}`),
      onSuccess: () => {
        showToast("success", "Faq deleted successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_FAQ);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
